import React, {FC, ReactElement} from 'react';
import './MultipleButtons.scss';
import styled from 'styled-components';
import type {multipleButtonsProps} from './MultipleButtons';
import {MultipleButtonsWrapper} from './MultipleButtons';
import Element from '../Element';

const MultipleButtonsEditor = styled(MultipleButtonsWrapper)`

`

const MultipleButtons: FC<multipleButtonsProps> = ({...props}): ReactElement => {

    const useAppSelector = props.editorPlugins.useAppSelector;
    const useAppDispatch = props.editorPlugins.useAppDispatch;
    const selectActive = props.editorPlugins.selectActive;
    const selectActiveSet = props.editorPlugins.selectActiveSet;
    const openElementsLibrary = props.editorPlugins.openElementsLibrary;
    const Add = props.editorPlugins.addButton;
    const dispatch = useAppDispatch();

    function getPath(index: number) {
        if (!props.path) return null;
        let path = {...props.path};
        path.elementIndex = props.index;
        path.subElementIndex = index;
        return path;
    }

    function clickOpenElementsLibrary() {
        let path = {...props.path};
        path.elementIndex = -1;
        dispatch(selectActive(path));
        let data = {
            path: path,
            type: 'element'
        };
        dispatch(selectActiveSet(''));
        return dispatch(openElementsLibrary(data));
    }

    return (
        <MultipleButtonsEditor className={'multiButtons'}>
            <div className={'buttonsList'}>
                {
                    props.buttonsData.map((element: any, index: number) => {
                        return (<div key={index} className={'listItem'}>
                                <Element key={index} index={index} path={getPath(index)} editorPlugins={props.editorPlugins} elementData={element}/>
                            </div>
                        )
                    })
                }
            </div>
        </MultipleButtonsEditor>
    )

};

export default MultipleButtons;
